import { CancelQuoteAction } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions/cancel';
import { EssentialHelpCenterAction } from 'routes/essential-workspace/components/quote-panel/quote/quote-actions/help-center';

export function RejectedQuoteActions() {
  return (
    <div className="flex-x gap-2 w-100">
      <EssentialHelpCenterAction className="w-100" />
      <CancelQuoteAction className="w-100" isDismiss />
    </div>
  );
}
